import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import Layout from "../utils/layout";
import { STATIC_GROUPS } from "../constants/constants";
import useStore from "../hooks/useStore";
import { observer } from "mobx-react";
import info from "./info.svg";
import numToRoman from "../helpers/numToRoman";
import CustomTooltip from "../utils/tooltip/tooltip";
import { groupByConsecutiveGroups } from "../utils/helpers";
import { addGroupData } from "../helpers/groupDataCalculations";
import * as XLSX from 'xlsx';


function ShowDataRow({ data, id }) {
  const {
    companyStore: { units },
  } = useStore();
  //console.log("show row",data)
  return (
    <tr className="odd removeinput" key={id}>
      <td>{!id && id !== 0 ? "*" : numToRoman(id + 1)}</td>
      <td>
        <span
          style={{
            display: "flex",
            gap: "5px",
          }}
        >
          {data?.fieldName}
          {data?.guidance && (
            <CustomTooltip position="top" content={data?.guidance}>
              <img src={info} alt="" />
            </CustomTooltip>
          )}
        </span>
      </td>
      <td>
        <span>
          {
            units?.find((ele) => ele.id === (data?.unitId || data?.unit))
              ?.shortName
          }
        </span>
      </td>

      <td>
        <div>{data?.frequencyType || ""}</div>
        <div>{data?.frequencyDate || data?.frequencyMonth || ""}</div>
        <div>{data?.frequencyYear || ""}</div>
      </td>

      <td className="text-center">
        <span>{data.prevValue}</span>
      </td>
      <td className="text-center">
        <span>{data.target}</span>
      </td>
      <td>
        <span>{data.comment}</span>
      </td>
      <td>
        {data?.attachment && data.attachment.length > 0 ? (
          data.attachment.map((file, index) => {
            const fileUrlObj = data.url.find((item) => item.attachment === file);
            const fileUrl = fileUrlObj ? fileUrlObj.url : "#";

            return (
              <div key={index}>
                <Link to={fileUrl} rel="noopener noreferrer">
                  Download {index + 1}
                </Link>
              </div>
            );
          })
        ) : (
          <div>N/A</div>
        )}
      </td>

    </tr>
  );
}

function RowTotal({ id, data, className }) {
  return (
    <tr className={`subTotalTr ${id}-footer ${className}`}>
      <td>
        <b>{""}</b>
      </td>
      <td
        colspan=""
        style={{
          fontWeight: "600",
        }}
      >
        Total
      </td>
      <td></td>
      <td></td>
      <td className="totalTd">{data?.prevValue}</td>
      <td className="totalTd">{data?.target}</td>
      <td></td>
      <td></td>
      {/* <td></td> */}
    </tr>
  );
}

function FormTableBody({ data, page }) {
 
  const values = useMemo(
    () =>
      (
        groupByConsecutiveGroups(
          data?.value?.sort((a, b) => Number(a.fieldId) - Number(b.fieldId))
        ) || []
      )?.map((value) => ({
        label: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(
          value[0]?.group
        )
          ? ""
          : STATIC_GROUPS[page][value[0]?.group],
        value,
        group: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"].includes(
          value[0]?.group
        )
          ? ""
          : value[0]?.group,
      })),
    [data?.value, page]
  );
  let id = 0;
  return values?.map((ele, index) => (
    <>
      {!ele?.group ? null : (
        <>
   
        <tr className="table-sub-heading">
          <td>{numToRoman(id++ + 1)}</td>
          <td colSpan={7}>{ele.label}</td>
        </tr>
       
      </>
      )}
      {ele.value.map((e, i) => (
        
        <ShowDataRow data={e} id={!ele.label ? id++ : null} />
      ))}
      {ele?.value?.length !== 1 && (
        <RowTotal id={"asdfasacc"} data={addGroupData(ele.value)} />
      )}
    </>
  ));
}

// const DataPage = () => {
//   const location = useLocation();
//   const {
//     state: { formId, page },
//   } = location;
//   const {
//     userStore: { isLoggedIn },
//     formStore: { data, getFormData },
//     companyStore: { fetchUnits },
//   } = useStore();
//   useEffect(() => {
//     getFormData({ formId, type: page });
//     fetchUnits();
//   }, [fetchUnits, formId, getFormData, page]);
//   const groupData = useMemo(
//     () =>
//       Object.entries(
//         data?.reduce((acc, curr) => {
//           if (acc?.[curr?.group?.[0]]) {
//             return {
//               ...acc,
//               [curr?.group?.[0]]: [...acc[curr?.group?.[0]], curr],
//             };
//           }
//           return {
//             ...acc,
//             [curr?.group?.[0]]: [curr],
//           };
//         }, {})
//       ).map(([key, value]) => ({
//         group: key,
//         value,
//         label: STATIC_GROUPS[page][key],
//       })),
//     [data, page]
//   );
//   return (
//     <Layout>
//       <div className="add-water-page">
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-12">
//               <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                 <h4 className="mb-sm-0 font-size-18">List Of Details</h4>
//                 <div className="page-title-right">
//                   <ol className="breadcrumb m-0">
//                     <li className="breadcrumb-item text-capitalize">
//                       <Link
//                         to={isLoggedIn ? `/company/${page}` : `/admin/${page}`}
//                       >
//                         {page === "aqi" ? "Emission" : page} List
//                       </Link>
//                     </li>
//                     <li className="breadcrumb-item active">Form Details</li>
//                   </ol>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="card p-4">
//             <div className="table-responsive ">
//               <table className="table align-middle table-bordered table-nowrap mb-0">
//                 <thead>
//                   <tr className="waterTabletr">
//                     <th>Sr. No.</th>
//                     <th>Title</th>
//                     <th>Unit</th>
//                     <th>Frequency</th>
//                     <th>Current Value</th>
//                     <th>Target Value</th>
//                     <th>Comment</th>
//                     <th>Attachment</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {groupData?.map((raw, id) => (
//                      <React.Fragment key={`${page}-${id}`}>
//                       <tr className="table-heading">
//                         <td>{id + 1}</td>
//                         <td colSpan={7}>{raw.label}</td>
//                       </tr>
//                       {raw?.group === "B" && raw?.value[0]?.groupCDropdown && (
//                         <tr>
//                           <td colSpan={8}>
//                             <b>
//                             {raw?.value[0]?.groupCDropdown === "0"
//                               ? "Without Treatment"
//                               : raw?.value[0]?.groupCDropdown === "1"
//                               ? "With Treatment"
//                               : null}
//                               </b>
//                           </td>
//                         </tr>
//                       )}
//                       <FormTableBody data={raw} page={page} />
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default observer(DataPage);


const downloadExcel = (groupData, page,units) => {
  const getUnitDisplay = (item) => {
    const foundUnit = units?.find(
      (ele) => 
        ele.id === (item?.unitId || item?.unit) || 
        ele.fullName === item?.unit || 
        ele.shortName === item?.unit
    );
    return foundUnit?.shortName || foundUnit?.fullName || item?.unit || 'N/A';
  };
  // Flatten the grouped data into a single array of rows
  const flattenedData = groupData.flatMap(group => {
    // Add group label as a header row for each group
    const groupHeaderRow = [{
      'Sr. No.': '',
      'Title': group.label,
      'Unit': '',
      'Frequency': '',
      'Current Value': '',
      'Target Value': '',
      'Comment': '',
      'Attachment': ''
    }];

    // Convert group values to Excel rows
    const groupRows = group.value.map((item, index) => ({
      'Sr. No.': index + 1,
      'Title': item.fieldName || '',
      'Unit': getUnitDisplay(item),
      'Frequency': `${item.frequencyType || ''} ${item.frequencyDate || item.frequencyMonth || ''} ${item.frequencyYear || ''}`.trim(),
      'Current Value': item.prevValue || '',
      'Target Value': item.target || '',
      'Comment': item.comment || '',
      'Attachment': item.attachment && item.attachment.length > 0 
        ? item.attachment.map((file, idx) => 
            item.url && item.url[idx] ? item.url[idx].url : 'N/A'
          ).join(', ')
        : 'N/A'
    }));

    // Add total row if group has multiple values
    const totalRow = group.value.length > 1 
      ? [{
          'Sr. No.': '',
          'Title': 'Total',
          'Unit': '',
          'Frequency': '',
          'Current Value': group.value.reduce((sum, item) => sum + (Number(item.prevValue) || 0), 0),
          'Target Value': group.value.reduce((sum, item) => sum + (Number(item.target) || 0), 0),
          'Comment': '',
          'Attachment': ''
        }]
      : [];

    return [...groupHeaderRow, ...groupRows,];
  });

  // Create workbook and worksheet
  const worksheet = XLSX.utils.json_to_sheet(flattenedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, page || 'Sheet1');

  // Generate and download Excel file
  XLSX.writeFile(workbook, `${page}_details_${new Date().toISOString().split('T')[0]}.xlsx`);
};



const DataPage = () => {
  const location = useLocation();
  const {
    state: { formId, page, approvalStatus},
  } = location;
  const {
    userStore: { isLoggedIn },
    formStore: { data, getFormData },
    companyStore: { units,fetchUnits },
  } = useStore();

  useEffect(() => {

    getFormData({ formId, type: page });
  
    fetchUnits();
  }, [fetchUnits, formId, getFormData, page]);

  // const groupData = useMemo(() => {
  //   // Add null check to prevent error
  //   if (!data || data.length === 0) {
  //     return [];
  //   }

  //   return Object.entries(
  //     data.reduce((acc, curr) => {
  //       if (!curr?.group?.[0]) return acc;

  //       if (acc?.[curr.group[0]]) {
  //         return {
  //           ...acc,
  //           [curr.group[0]]: [...acc[curr.group[0]], curr],
  //         };
  //       }
  //       return {
  //         ...acc,
  //         [curr.group[0]]: [curr],
  //       };
  //     }, {})
  //   ).map(([key, value]) => ({
  //     group: key,
  //     value,
  //     label: STATIC_GROUPS[page]?.[key] || '', // Add fallback
  //   }));
  // }, [data, page]);

  const groupData = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }
  
    return Object.entries(
      data.reduce((acc, curr) => {
        // Ensure group exists and is not empty
        const groupKey = curr?.group?.[0] || 'unknown';
        
        if (acc?.[groupKey]) {
          return {
            ...acc,
            [groupKey]: [...acc[groupKey], curr],
          };
        }
        return {
          ...acc,
          [groupKey]: [curr],
        };
      }, {})
    ).map(([key, value]) => ({
      group: key,
      value,
      label: STATIC_GROUPS[page]?.[key] || key, // Fallback to key if no label
    }));
  }, [data, page]);
 
  if (!data) {
    return (
      <Layout>
        <div className="add-water-page">
          <div className="container-fluid">
            <div className="card p-4">
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="add-water-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">List Of Details</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item text-capitalize">
                      <Link
                        to={isLoggedIn ? `/company/${page}` : `/admin/${page}`}
                      >
                        {page === "aqi" ? "Emission" : page} List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Form Details</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-4">
          <div className="mb-3 text-right">
          <button 
                onClick={() => downloadExcel(groupData, page, units)} 
                className="btn btn-primary"
                disabled={groupData.length === 0 || approvalStatus !== 'approved'} // Disable if not approved
              >
                {approvalStatus !== 'approved' ? 'Download (Pending Approval)' : 'Download Excel'}
              </button>
            </div>
            <div className="table-responsive ">
              <table className="table align-middle table-bordered table-nowrap mb-0">
                <thead>
                  <tr className="waterTabletr">
                    <th>Sr. No.</th>
                    <th>Title</th>
                    <th>Unit</th>
                    <th>Frequency</th>
                    <th>Current Value</th>
                    <th>Target Value</th>
                    <th>Comment</th>
                    <th>Attachment</th>
                  </tr>
                </thead>
                <tbody>
                  {groupData?.length > 0 ? (
                    groupData.map((raw, id) => (
                      <React.Fragment key={`${page}-${id}`}>
                        <tr className="table-heading">
                          <td>{id + 1}</td>
                          <td colSpan={7}>{raw.label}</td>
                        </tr>
                        {raw?.group === "B" && raw?.value[0]?.groupCDropdown && (
                          <tr>
                            <td colSpan={8}>
                              <b>
                                {raw?.value[0]?.groupCDropdown === "0"
                                  ? "Without Treatment"
                                  : raw?.value[0]?.groupCDropdown === "1"
                                  ? "With Treatment"
                                  : null}
                              </b>
                            </td>
                          </tr>
                        )}
                        <FormTableBody data={raw} page={page} />
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8}>No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default observer(DataPage);
